import * as React from "react"
import meta from "../../Sprints/meta"
import CollapsableCard, { CollapsableCardBody, CollapsableCardHeader } from "../../../components/CollapsableCard/CollapsableCard"
import { StudentData } from "../types"
import { TeacherSprintStats, SprintQuestionStats, getQuestionPeriodStats, getStudentPeriod } from "../../../services/sprints/teacher-stats"
import SprintTeacherReview from "./SprintTeacherReview"

interface Props { subject: string, students: StudentData[], stats: TeacherSprintStats }

export default function TimedSprintsSections({ subject, students, stats }: Props) {
    let [review, setReview] = React.useState<{ question: SprintQuestionStats, video: boolean } | undefined>()
    let groups = meta.subjects[subject.toLowerCase() as keyof typeof meta.subjects] || []
    let periods = Array.from(new Set(students.map(getStudentPeriod))).sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
    let questions = stats.questions.filter(q => q.subject.toLowerCase() === subject.toLowerCase() && q.exam.toLowerCase() === "act")
    let roster = periods.map(period => ({ period, students: students.filter(student => getStudentPeriod(student) === period) }))

    if (!students.length) return <p>No students match the selected filters.</p>

    if (review) {
        alert("Will be available soon...")
    }

    return <>
        {groups.map((group, index) => <SprintCard key={`${subject}-${group.title}`} title={group.title} number={index + 1} subject={subject}>
            <div className="timed-sprints-section-body">
                {group.sprints.map(sprint => {
                    let sprintQuestions = questions.filter(q => q.sprintNumber === sprint).sort((a, b) => a.questionNumber - b.questionNumber)
                    return <SprintCard key={sprint} title={`Timed Sprint ${sprint}`} subject={subject}>
                        {!sprintQuestions.length ? <p>No question statistics available.</p> :
                            <div className="timed-sprints-table-scroll" tabIndex={0} role="region" aria-label={`Timed Sprint ${sprint} question statistics`}>
                                <table>
                                    <thead><tr><th scope="col">Sprint</th><th scope="col">#</th><th scope="col">Question</th><th scope="col">Explanation</th>
                                        {periods.map(period => <th scope="col" key={period}>{!isNaN(Number(period)) ? `Period ${period}` : period}</th>)}
                                    </tr></thead>
                                    <tbody>{sprintQuestions.map((question, index) => <tr key={question.questionNumber}>
                                        {index === 0 && <th scope="rowgroup" rowSpan={sprintQuestions.length}>Sprint {sprint}</th>}
                                        <th scope="row" className="timed-sprints-question-number">{question.questionNumber}</th>
                                        <td className="timed-sprints-icon-cell">
                                            <button className="btn-div" aria-label={`View Sprint ${sprint} 
                                                question ${question.questionNumber}`} 
                                                onClick={() => setReview({ question, video: false })}>
                                                    <img src="/assets/images/icons/v2/ico-modal.svg" width="22" height="22" alt="View question" />
                                            </button>
                                        </td>
                                        <td className="timed-sprints-icon-cell">
                                            <button className="btn-div" aria-label={`Watch Sprint ${sprint} 
                                                question ${question.questionNumber} explanation`} 
                                                onClick={() => setReview({ question, video: true })}>
                                                    <img src="/assets/images/icons/v2/ico-play.svg" width="22" height="22" alt="Watch explanation" />
                                            </button>
                                        </td>
                                        {roster.map(({ period, students }) => {
                                            let result = getQuestionPeriodStats(question, students)
                                            return <td key={period}>
                                                <strong title="Correct answers as a percentage of selected students">{Math.round(result.accuracy)}%</strong>
                                                <div className="timed-sprints-choices">{result.choices.map(choice => <span key={choice.label}>
                                                    <span>{choice.label}</span><span>{Math.round(choice.percent)}%</span>
                                                </span>)}</div>
                                            </td>
                                        })}
                                    </tr>)}</tbody>
                                </table>
                            </div>}
                    </SprintCard>
                })}
            </div>
        </SprintCard>)}
        {/* {review && 
            <SprintTeacherReview key={`${review.question.timedSprintId}-${review.question.questionNumber}-${review.video}`}
                question={review.question} 
                video={review.video} 
                onClose={() => setReview(undefined)} 
            />
        } */}
        
    </>
}

function SprintCard({ title, number, subject, children }: { title: string, number?: number, subject: string, children: React.ReactNode }) {
    return <CollapsableCard initiallyCollapsed={true}>
        <CollapsableCardHeader>
            <div className="lesson-list-card-header">
                {number !== undefined && <span className={`ribbon ${subject}`}>
                    <span className="bellringers-grade-level">{number}</span>
                </span>}
                <h2 className="lesson-list-card-header--text">{title}</h2>
            </div>
        </CollapsableCardHeader>
        <CollapsableCardBody>{children}</CollapsableCardBody>
    </CollapsableCard>
}
